module.exports = __webpack_public_path__ + "static/media/Unarchive.e9b3e21f.svg";